var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "car-card",
      on: {
        click: function ($event) {
          return _vm.routeToBrand(_vm.data.id)
        },
      },
    },
    [
      _c("ImgComponent", {
        staticClass: "car-card__img",
        attrs: { head_img: _vm.data.img },
      }),
      _c("span", { staticClass: "car-card__text" }, [
        _vm._v(_vm._s(_vm.data.products_count) + "\n    "),
        _c("span", { staticClass: "car-card__title" }, [
          _vm._v(
            _vm._s(
              _vm._f("plural_word")(
                _vm.data.products_count,
                "товар",
                "товара",
                "товаров"
              )
            )
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }